import React, { useState, useEffect, useRef, useCallback } from 'react';
import classnames from 'classnames';
import arrow_down from '../../../images/icons/arrow_down.svg';
import checked_icon from '../../../images/icons/checked_icon.svg';

import useOutsideClick from './useOutsideClick';
import './CommonSelect.css';
import { debounce } from 'lodash';

function CommonSelect({
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  options,
  errorMsg,
  isHoverEffect,
  styleText = {},
  stylesContainer = {},
  dropdownStyle = {},
  styleDropdownlist = {},
  spanStyle = {},
  disabled,
  sort = false,
  optionRefParent,
  useParentOptionRef,
  useTimeOut,
  timeOutValue
}) {
  const optionsRef = React.useRef(null);
  const [showOption, setShowOption] = useState(false);
  const [sortedOption, setSortedOptions] = useState([]);
  const [optionSeachKey, setOptionSearchKey] = useState('');
  const optionSeachKeyRef = useRef(optionSeachKey);
  const [valueLocked, setvalueLocked] = useState(0);
  const isClickedOutside = useOutsideClick(myRef);
  const myRef = useRef(null);
  const optionList = useRef(sortedOption);
  const valueLOckerRef = useRef(valueLocked);

  const sortTheOption = () => {
    if (typeof options != 'object') return;
    let sortedOption = options.sort(function(a, b) {
      if (!a.value || !b.value) return 0;
      if (a.label < b.label) return -1;
      else if (a.label > b.label) return 1;
      return 0;
    });
    optionList.current = sortedOption;
    setSortedOptions(sortedOption);
  };

  const reArrangeTheScroll = index => {
    let currChild;
    if (useParentOptionRef)
      currChild = optionRefParent?.current?.children?.[index];
    else currChild = optionsRef?.current?.children?.[index];
    currChild?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  };
  const handleAlignOptionInScroll = (value, index) => {
    setvalueLocked(index);
    valueLOckerRef.current = index;
    reArrangeTheScroll(index);
  };

  const clearKeyPress = useCallback(
    debounce(() => {
      setOptionSearchKey('');
      optionSeachKeyRef.current = '';
    }, 700),
    []
  );

  const hideOptionDiv = () => {
    if (useTimeOut && timeOutValue) {
      setTimeout(() => {
        setShowOption(false);
      }, timeOutValue);
    } else setShowOption(false);
  };
  const handleOptionOnKeyPress = value => {
    optionList.current?.find((each, index) => {
      if (
        each?.value &&
        `${each?.label}`
          ?.toString()
          ?.toLowerCase()
          ?.startsWith(value?.toString()?.toLowerCase() || '')
      ) {
        handleAlignOptionInScroll(each, index);
        return true;
      }
      return false;
    });
  };

  const handleEscapeKey = () => {
    setOptionSearchKey('');
    optionSeachKeyRef.current = '';
    return;
  };

  const handleArrowDown = () => {
    if (valueLOckerRef.current == optionList?.current?.length - 1) {
      setvalueLocked(0);
      valueLOckerRef.current = 0;
    } else {
      setvalueLocked(valueLOckerRef.current + 1);
      valueLOckerRef.current = valueLOckerRef.current + 1;
    }
    reArrangeTheScroll(valueLOckerRef.current);
  };

  const handleArrowUp = () => {
    if (valueLOckerRef.current == 0) {
      setvalueLocked(optionList?.current?.length - 1);
      valueLOckerRef.current = optionList?.current?.length - 1;
    } else {
      setvalueLocked(valueLOckerRef.current - 1);
      valueLOckerRef.current = valueLOckerRef.current - 1;
    }
    reArrangeTheScroll(valueLOckerRef.current);
  };

  const handleKeys = e => {
    if (optionList?.current?.length > 0) {
      let newVal = `${optionSeachKeyRef.current}${e?.key}`;
      setOptionSearchKey(newVal);
      optionSeachKeyRef.current = newVal;
      handleOptionOnKeyPress(newVal);
      clearKeyPress();
    }
  };

  const handleEnter = () => {
    let each = optionList.current[valueLOckerRef?.current];
    if (!each.disable) {
      onChange(each); //onchangeDate
      hideOptionDiv();
    }
  };

  const handleKeyPress = e => {
    if (e?.key == 'Escape') {
      return handleEscapeKey();
    }
    if (e?.key == 'Enter') {
      return handleEnter();
    }

    if (e?.key == 'ArrowDown') {
      e.preventDefault();
      return handleArrowDown();
    }
    if (e?.key == 'ArrowUp') {
      e.preventDefault();

      return handleArrowUp();
    } else handleKeys(e);
  };

  useEffect(() => {
    myRef?.current?.addEventListener('keydown', handleKeyPress);
    return () => {
      myRef?.current?.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  useEffect(() => {
    if (sort) sortTheOption();
    else {
      setSortedOptions(options);
      optionList.current = options;
      setSortedOptions(options);
    }
  }, [options]);

  useEffect(() => {
    if (isClickedOutside) {
      hideOptionDiv();
      if (onBlur) {
        onBlur();
      }
    }
  }, [isClickedOutside]);

  const containerClasses = classnames(
    `w-full py-auto text-base text-black-600 font-roboto font-normal relative rounded  hover:border  `,
    {
      'border border-red-300': error && touched,
      'border border-green-600': !error && touched,
      'border border-grey-350': !touched
    },
    {
      ' hover:border-green-600 ': !isHoverEffect
    },
    {
      ' hover:border-black-0 focus:border-blue-700 focus:border-2': isHoverEffect
    },
    {
      'cursor-not-allowed ': disabled
    }
  );

  return (
    <div
      tabIndex="0"
      className={containerClasses}
      ref={myRef}
      style={stylesContainer}
      onFocus={e => {
        if (!disabled) setShowOption(true);
      }}
      onBlur={() => {
        if (!disabled) hideOptionDiv();
      }}
    >
      <div
        onClick={e => {
          if (!disabled) setShowOption(true);
        }}
        className={
          (disabled ? 'cursor-not-allowed ' : 'cursor-pointer ') +
          ' selected_month  rounded w-full text-xs'
        }
        style={styleText}
      >
        <span className="" style={spanStyle}>
          {value ? value.label : 'Select'}{' '}
        </span>
        <span>
          <img src={arrow_down} className="arrow_icon text-green-600" alt="" />
        </span>
      </div>
      {showOption && options.length > 0 && (
        <div
          className=" all_dropdown w-full absolute text-sm "
          ref={useParentOptionRef ? optionRefParent : optionsRef}
          style={{
            top: '40px',
            zIndex: 11000000000,
            left: 0,
            ...dropdownStyle
          }}
        >
          {sortedOption &&
            sortedOption.map((each, i) => {
              return (
                <div
                  key={i}
                  className={`${valueLocked == i && 'bg-skyBlue-halfBaked'} ${
                    each.disable ? 'opacity-50' : 'cursor-pointer'
                  }`}
                  name={name}
                  onClick={e => {
                    if (!each.disable) {
                      onChange(each); //onchangeDate
                      hideOptionDiv();
                    }
                  }}
                  style={styleDropdownlist}
                >
                  <span key={i}>{each.label}</span>
                  {value.value === each.value && (
                    <span>
                      <img className="checked_icon" src={checked_icon} alt="" />
                    </span>
                  )}
                </div>
              );
            })}
        </div>
      )}

      {error && errorMsg && (
        <div className="mt-1 text-xs text-red-300 text-left">{errorMsg}</div>
      )}
    </div>
  );
}

export default CommonSelect;
